/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_As_Of_Back_To_LiveInputs */

const en_cargos_as_of_back_to_live = /** @type {(inputs: Cargos_As_Of_Back_To_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to live`)
};

const es_cargos_as_of_back_to_live = /** @type {(inputs: Cargos_As_Of_Back_To_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a en vivo`)
};

/**
* | output |
* | --- |
* | "Back to live" |
*
* @param {Cargos_As_Of_Back_To_LiveInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_as_of_back_to_live = /** @type {((inputs?: Cargos_As_Of_Back_To_LiveInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_As_Of_Back_To_LiveInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_as_of_back_to_live(inputs)
	return es_cargos_as_of_back_to_live(inputs)
});